<template>
  <div class="action-page">
    <img
      class="mic-on"
      src="@/components/VoiceRoom/images/voice_room_mic_off.webp"
      alt=""
      @click="openMic()"
      v-if="!isOpenMic"
    />
    <img
      class="mic-on"
      src="@/components/VoiceRoom/images/voice_room_mic_on.webp"
      alt=""
      @click="closeMic()"
      v-if="isOpenMic"
    />
    <img
      class="icon-gift"
      src="@/components/VoiceRoom/images/voice_room_gift.png"
      alt=""
      @click.stop="handleSendGift()"
    />
    <gift-vue ref="gift"></gift-vue>
  </div>
</template>
<script>
import CurrentUserProvider from '@/components/VoiceRoom/currentUserProvider';
import mRtc from '@/components/VoiceRoom/mRtc';
import GiftVue from '@/components/VoiceRoom/component/gift.vue';
import VoiceRoomProvider from '@/components/VoiceRoom/voiceRoomProvider';

export default {
  name: 'ActionPage',
  components: {
    GiftVue
  },
  data() {
    return {
      userList: []
    };
  },
  watch: {},
  computed: {
    roomId() {
      return VoiceRoomProvider.roomInfo
        ? VoiceRoomProvider.roomInfo.roomUid
        : '';
    },
    userInfo() {
      return CurrentUserProvider.userInfo;
    },
    uuid() {
      return this.userInfo.uuid;
    },
    // 是否已开麦
    isOpenMic() {
      return mRtc.isOpenMic;
    }
    // sendGiftUserList() {
    //   const list = [
    //     // {
    //     //   isSelect: true,
    //     //   user: {
    //     //     avatarURL: userInfo.avatarUrl,
    //     //     userUuid: userInfo.uuid
    //     //   }
    //     // }
    //   ];
    //   return list;
    // }
  },
  methods: {
    async openMic() {
      try {
        await mRtc.openMic();
      } catch (error) {
        console.log(error);
      }
    },
    async closeMic() {
      await mRtc.closeMic();
    },
    handleSendGift() {
      this.$emit('hanleSendGift');
    },
    sendGift(userList, toTargetUser) {
      this.$refs.gift.init(userList, toTargetUser);
    }
  },
  created() {}
};
</script>
<style lang="scss" scoped>
.action-page {
  padding: 0 20px 40px;
  height: 42px;
  display: flex;
  align-items: center;
  width: 100%;
  img {
    width: 36px;
  }
  .icon-gift {
    width: auto;
    height: 42px;
    margin-left: 10px;
  }
  .mic-on {
    width: auto;
    height: 42px;
  }
}
</style>
